import { render, staticRenderFns } from "./NotRatedOptionReasons.vue?vue&type=template&id=2da23b46"
import script from "./NotRatedOptionReasons.vue?vue&type=script&lang=ts"
export * from "./NotRatedOptionReasons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports